/**
 * Redirect helpers — Django allauth session auth.
 * Cross-origin: absolute URLs on Django host; same-origin: relative paths.
 */

import { CLASSIC_SITE_BASE } from "../classicSite.constants";
import {
  getLoginRedirectUrl,
  getLogoutRedirectUrl,
  getSignupRedirectUrl,
} from "./sessionHelpers";
import { isCrossOriginDjango } from "./djangoOrigin";

/**
 * Navigate to Classic Site login page (in-app form) or Django login when same-origin.
 * @param {string} [returnPath]
 */
export function redirectToLogin(returnPath) {
  if (typeof window === "undefined") return;

  const next =
    returnPath ||
    `${window.location.pathname}${window.location.search}`;

  if (isCrossOriginDjango()) {
    const params = new URLSearchParams({ next });
    window.location.assign(`${CLASSIC_SITE_BASE}/login?${params.toString()}`);
    return;
  }

  window.location.assign(getLoginRedirectUrl(returnPath));
}

/** Alias for redirectToLogin */
export function login(returnPath) {
  redirectToLogin(returnPath);
}

/**
 * Redirect to django-allauth logout (ACCOUNT_LOGOUT_ON_GET = True).
 * @param {string} [returnPath]
 */
export function logout(returnPath = CLASSIC_SITE_BASE) {
  if (typeof window === "undefined") return;
  window.location.assign(getLogoutRedirectUrl(returnPath));
}

/**
 * Redirect to Django signup.
 * @param {string} [returnPath]
 */
export function redirectToSignup(returnPath) {
  if (typeof window === "undefined") return;
  window.location.assign(getSignupRedirectUrl(returnPath));
}

/**
 * Full navigation to Django-hosted login (bypass in-app form).
 * @param {string} [returnPath]
 */
export function redirectToDjangoLoginPage(returnPath) {
  if (typeof window === "undefined") return;
  window.location.assign(getLoginRedirectUrl(returnPath));
}

export { getLoginRedirectUrl, getLogoutRedirectUrl, getSignupRedirectUrl };
